import { View } from 'foundations-components/transitional/components/View';
import { isTrellisTheme, useTheme } from 'foundations-theming/utils';
import FeatureTableBadge from 'pricing-pages-ui-components/badges/FeatureTableBadge';
import { MerchCardBadge } from 'pricing-pages-ui-components/badges/MerchCardBadge';
import { useAppSelector } from '../../../reducers';
import { isAppAuthSelector } from '../../../selectors/AuthSelectors';
import { isUngatedForInbound25Selector } from '../../../selectors/GatingSelectors';
import { jsx as _jsx } from "react/jsx-runtime";
export const RecommendedBadge = () => {
  const isAppAuth = useAppSelector(isAppAuthSelector);
  const isUngatedForInbound25 = useAppSelector(isUngatedForInbound25Selector);
  const theme = useTheme();
  const isTrellis = isTrellisTheme(theme);
  const shouldShowTrellisBadge = isTrellis && isUngatedForInbound25;
  if (shouldShowTrellisBadge) {
    return /*#__PURE__*/_jsx(MerchCardBadge, {
      translationKey: isAppAuth ? 'pricing-pages-ui.merchCardsV2.badges.RECOMMENDED' : 'pricing-pages-ui.merchCardsV2.badges.MOST_POPULAR',
      badgeColor: isAppAuth ? 'fill-primary-default' : 'specialty-tertiary-on-fill-default',
      isAppAuth: isAppAuth
    });
  }
  return /*#__PURE__*/_jsx(View, {
    position: "absolute",
    insetBlockStart: "200",
    insetInlineEnd: "200",
    children: /*#__PURE__*/_jsx(FeatureTableBadge, {
      translationKey: isAppAuth ? 'recommended' : 'mostPopular'
    })
  });
};